import { ButtonProps } from 'antd';
import { GrayOutlinedButton } from 'components/button/button-grayoutline';
import { ConcussionRxPrintContextConsumer } from 'lib/utils/print';
import { Text } from '../mvp-typography';
import { ErrorDisplay } from 'components/ErrorDisplay';

export function ExportAsPDFButton({
  text = 'Print Rx',
  ...props
}: Omit<ButtonProps, 'onClick' | 'disabled' | 'loading' | 'title'> & {
  text?: string;
}) {
  return (
    <ConcussionRxPrintContextConsumer>
      {args => (
        <div>
          <GrayOutlinedButton
            {...props}
            style={{ ...props.style }}
            onClick={() => {
              if (args.isPrinting) return;
              args.handlePrint();
            }}
            loading={args.isPrinting}
            disabled={args.isPrinting}
          >
            {text}
          </GrayOutlinedButton>
          {args.status && !args.hasError && (
            <Text style={{ fontSize: '0.5rem' }}>{args.status}</Text>
          )}
          {
            args.hasError && <ErrorDisplay title='Safely handled PDF print failure' description='Please report this error to the ConcussionRx team' error={args.error} />
          }
          
        </div>
      )}
    </ConcussionRxPrintContextConsumer>
  );
}
